import React, { useState } from "react";
import {
  Button,
  Checkbox,
  Col,
  Drawer,
  Form,
  Input,
  Modal,
  Popover,
  Row,
  Table,
} from "antd";
import styled from "styled-components";
import COLORS from "../../../common/Colors";
import AccountStyle from "./style";
import { SearchOutlined, DownloadOutlined, FormOutlined, DeleteOutlined } from "@ant-design/icons";
import EditIcon from "../../../assets/Icons/edit.svg";
import { ReactComponent as DollerIcon } from "../../../assets/Icons/dollar.svg";
import DeleteIcon from "../../../assets/Icons/delete.png";

const StyledImg = styled.img`
  cursor: pointer;
  // width: 22px;
  display: inline;

  .editIcon{
    font-size: 20px;
  }
  .deleteIcon{
    font-size: 20px;
  }
`;

const StyledTable = styled(Table)`
  padding-top: 20px;
  table {
    width: 100% !important;
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    border: 1px solid #00000024;
    border-radius: 10px;
  }
  .ant-table-cell {
    padding: 20px;
  }
  .normal-column {
    min-width: 300px;
    white-space: normal;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: 600;
    font-size: 0.9rem;
    color: ${COLORS.SECONDARY_BLACK};
    white-space: nowrap;
  }
  .non-white {
    background: #f9f9f9;
  }
  .ant-table-thead > tr > th::before {
    display: none !important;
  }

  .ant-table-cell-row-hover {
    background: #e3e8fc !important;
  }
`;

const AccountCategory = () => {
  const [hoveredRowKey, setHoveredRowKey] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  const hanldeClickEdit = () => {};
  const columns1 = [
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      sorter: (a, b) => a.category - b.category,
    },
    {
      title: "Courses",
      dataIndex: "courses",
      key: "courses",
    },
    {
      title: "Parent category",
      dataIndex: "parentCategory",
      key: "parentCategory",
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
    },
    {
      title: "",
      dataIndex: "edit",
      key: "edit",
      width: "7%",
      render: (text, record) => {
        return (
          <>
            <AccountStyle>
              <div className="hover_icons">
              {/* <StyledImg> */}
                <FormOutlined
                  // className={hoveredRowKey === record.key ? 'download-icon show' : ''}
                  className="editIcon"
                  onClick={(e) => {
                    e.stopPropagation();
                    showDrawer();
                    hanldeClickEdit(record);
                  }}
                />

                <DeleteOutlined
                  // className={hoveredRowKey === record.key ? 'download-icon show' : ''}
                  className="deleteIcon"
                  onClick={(e) => {
                    e.stopPropagation();
                    setDeleteModal(!deleteModal);
                  }}
                />
              {/* </StyledImg> */}
              </div>
            </AccountStyle>
          </>
        );
      },
    },
  ];

  const dataSource1 = [
    {
      key: 1,
      category: "Samples",
      courses: "2",
      parentCategory: "-",
      price: "-",
    },
    {
      key: 2,
      category: "Samples",
      courses: "1",
      parentCategory: "-",
      price: "-",
    },
  ];

  const handleRowHover = (record) => {
    setHoveredRowKey(record.key); // Set the hovered row key
  };

  const handleRowLeave = () => {
    setHoveredRowKey(null); // Reset on row leave
  };

  return (
    <>
      <AccountStyle>
        <Row className="users-menu-filter-container">
          <Col>
            <Form.Item name="search" className="search-input-field">
              <Input suffix={<SearchOutlined />} placeholder="Search" />
            </Form.Item>
          </Col>

          <Col>
            <Button
              className="add-user-button"
              onClick={() => showDrawer(true)}
            >
              Add category
            </Button>
          </Col>
        </Row>
        <StyledTable
          dataSource={dataSource1}
          columns={columns1}
          rowClassName={(record, index) => (index % 2 === 0 ? "" : "non-white")}
          // onRow={(record) => ({
          //     onMouseEnter: () => handleRowHover(record),
          //     onMouseLeave: handleRowLeave,
          // })}
          rowKey="key"
          id="Table"
        />

        <div className="download_csv_con">
          <Popover placement="top" content="Save as CSV">
            <DownloadOutlined />
          </Popover>
        </div>

        <Modal
          title={<p>Delete category?</p>}
          open={deleteModal}
          footer={false}
          onCancel={() => setDeleteModal(false)}
        >
          <AccountStyle>
            <p>Are you sure you want to delete the category Samples?</p>
            <Form.Item>
              <Checkbox>Don't ask again.</Checkbox>
            </Form.Item>

            <Button className="delete_button">Delete</Button>
            <Button
              className="cancel_button"
              onClick={() => setDeleteModal(false)}
            >
              Cancel
            </Button>
          </AccountStyle>
        </Modal>

        <Drawer title="Edit category" onClose={onClose} open={open} width={600}>
          <Form
            layout="vertical"
            initialValues={{
              remember: true,
            }}
            form={form}
            autoComplete="off"
          >
            <Form.Item label="Name" name="name" className="form_input_label">
              <Input className="" />
            </Form.Item>
            <Form.Item
              label="Parent category"
              name="parentCategory"
              className="form_input_label"
            >
              <Input className="" />
            </Form.Item>
            <Form.Item label="Price" name="price" className="form_input_label">
              <Input addonAfter={<DollerIcon width={20} height={20} />} />
            </Form.Item>
          </Form>
        </Drawer>
      </AccountStyle>
    </>
  );
};

export default AccountCategory;
